var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import StyleConfTemplate from '../StyleConfTemplate';
import SizeInput from '../widgets/sizeInput';
import { radiusOptions, borderOptions, pathAttrs, wholeBorderPath, concreteBorderPath, getUnit, getNumber } from './borderUtils';
let BorderRadius = class BorderRadius extends Vue {
  constructor() {
    super(...arguments);
    this.selectedBorderRadius = 'border';
  }
  get parsed() {
    return Object.entries(this.borderFieldSetRadiuses).reduce((acc, [key, value]) => {
      if (key !== 'borderRadius' && (value === '0px' || !value)) {
        Object.assign(acc, {
          [key]: this.borderFieldSetRadiuses.borderRadius
        });
      } else Object.assign(acc, {
        [key]: value
      });
      return acc;
    }, {});
  }
  borderWidthChange(val, radius) {
    if (typeof val === 'string') {
      this.$emit('change', [`${radius}Radius`, val, this.selectedBorderRadius]);
    } else {
      this.$emit('change', [`${radius}Radius`, `${val}${getUnit(this.parsed[`${radius}Radius`])}`, this.selectedBorderRadius]);
    }
  }
  get changed() {
    return Object.values(this.parsed).some(val => val && val !== '0px');
  }
  reset() {
    this.$emit('change', ['borderRadius', null, 'border']);
    this.selectedBorderRadius = 'border';
  }
  render() {
    const h = arguments[0];
    return h(StyleConfTemplate, {
      "attrs": {
        "name": "边框圆角",
        "inline": true,
        "changed": this.changed
      },
      "on": {
        "reset": this.reset
      }
    }, [h("div", {
      "class": "uc-stylePanel-inline-content"
    }, [h("div", {
      "class": ['uc-stylePanel-border-box-option', `${this.selectedBorderRadius === 'border' ? 'selected' : ''}`],
      "on": {
        "click": () => this.selectedBorderRadius = 'border'
      }
    }, [h("svg", {
      "attrs": {
        ...borderOptions
      }
    }, [h("path", {
      "attrs": {
        "d": wholeBorderPath,
        ...pathAttrs
      }
    })])]), h("div", {
      "class": ['uc-stylePanel-border-box-option', `${this.selectedBorderRadius === 'concrete' ? 'selected' : ''}`],
      "on": {
        "click": () => this.selectedBorderRadius = 'concrete'
      }
    }, [h("svg", {
      "attrs": {
        ...borderOptions
      }
    }, [h("path", {
      "attrs": {
        "d": concreteBorderPath,
        ...pathAttrs
      }
    })])]), this.selectedBorderRadius === 'border' ? h("div", {
      "class": "uc-stylePanel-sliderInput-wrapper"
    }, [h("a-slider", {
      "class": "uc-stylePanel-inline-slider",
      "attrs": {
        "min": 0,
        "max": 20,
        "value": Math.min(20, +getNumber(this.parsed.borderRadius))
      },
      "on": {
        "change": val => this.borderWidthChange(val, 'border')
      }
    }), h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "unit": getUnit(this.parsed.borderRadius),
        "placeholder": "4",
        "value": getNumber(this.parsed.borderRadius)
      },
      "on": {
        "change": val => this.borderWidthChange(val, 'border')
      }
    })]) : h("div", {
      "class": "uc-stylePanel-borderRadius-concrete"
    }, [radiusOptions.map(option => h("div", {
      "class": "uc-stylePanel-borderRadius-concrete-wrapper"
    }, [h("div", {
      "class": "uc-stylePanel-border-box-option"
    }, [h("svg", {
      "attrs": {
        ...borderOptions
      }
    }, [h("path", {
      "attrs": {
        "d": option.out,
        ...pathAttrs
      }
    }), h("path", {
      "attrs": {
        "d": option.in
      }
    })])]), h("div", {
      "class": "uc-stylePanel-sliderInput-wrapper"
    }, [h(SizeInput, {
      "class": "uc-stylePanel-inline-input",
      "attrs": {
        "unit": getUnit(this.parsed[`border${option.title}Radius`] || this.parsed.borderRadius),
        "value": getNumber(this.parsed[`border${option.title}Radius`] || this.parsed.borderRadius),
        "placeholder": "4"
      },
      "on": {
        "change": val => this.borderWidthChange(val, `border${option.title}`)
      }
    })])]))])])]);
  }
};
__decorate([Prop({
  required: true,
  type: Object
})], BorderRadius.prototype, "borderFieldSetRadiuses", void 0);
BorderRadius = __decorate([Component({
  name: 'BorderRadius'
})], BorderRadius);
export default BorderRadius;
//# sourceMappingURL=borderRadius.js.map
